import { computed } from 'vue'

/**
 * Composable pour les computed properties du calendrier
 * Limite: 50 lignes max
 */
export function useCalendarComputed(currentMonth, currentYear, selectedDates, minSelectableDate) {
  const currentMonthYear = computed(() => {
    const date = new Date(currentYear.value, currentMonth.value, 1)
    return date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
  })

  const calendarDays = computed(() => {
    const firstDay = new Date(currentYear.value, currentMonth.value, 1)
    const startDate = new Date(firstDay)
    
    const dayOfWeek = startDate.getDay()
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1
    startDate.setDate(startDate.getDate() - daysToSubtract)
    
    const days = []
    
    for (let i = 0; i < 42; i++) {
      const date = new Date(startDate)
      date.setDate(startDate.getDate() + i)
      days.push({
        date: date,
        isOtherMonth: date.getMonth() !== currentMonth.value
      })
    }
    
    return days
  })

  const isPreviousMonthDisabled = computed(() => {
    const firstDayOfCurrentMonth = new Date(currentYear.value, currentMonth.value, 1)
    const firstDayOfMinMonth = new Date(minSelectableDate.getFullYear(), minSelectableDate.getMonth(), 1)
    return firstDayOfCurrentMonth <= firstDayOfMinMonth
  })

  const sortedSelectedDates = computed(() => {
    return [...selectedDates.value].sort()
  })

  return {
    currentMonthYear,
    calendarDays,
    isPreviousMonthDisabled,
    sortedSelectedDates
  }
}
